import { hiddenUserData } from "helpers/hiddenData";
import React from "react";

const ContractNumber = ({ contractNumber, roles }) => {
    if (!contractNumber) {
        return null;
    }
    return (
        <>
            <div className="show-bid__main-info--title">Номер договора с контрагентом</div>
            <div className="show-bid__main-info--value" data-test-id="contract-number">
                {hiddenUserData(contractNumber, { type: "title" }, roles.isTruckingOrganizationDispatcher)}
            </div>
        </>
    );
};

export default ContractNumber;
